import { FunctionComponent, PropsWithChildren } from 'react';

import { getIsBffFeatureEnabled } from '@/helpers/getIsBffFeatureEnabled';

import { useAppContext } from './App.context.base';
import { OidcAppContextProvider } from './App.context.oidc';
import { SessionAppContextProvider } from './App.context.session';
import { AppContextArgs } from './App.context.types';

const AppContextProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  if (getIsBffFeatureEnabled()) {
    return <SessionAppContextProvider>{children}</SessionAppContextProvider>;
  }

  return <OidcAppContextProvider>{children}</OidcAppContextProvider>;
};

export type { AppContextArgs };
export { AppContextProvider, useAppContext };
